import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'warning-dialog',
  templateUrl: './warning-dialog.component.html'
})
export class WarningDialogComponent {
  @Input() cancelText = 'Close';
  @Input() title = 'Warning';
  @Input() text: string;

  @Output() close = new EventEmitter<void>();

  onClose(): void {
    this.close.emit();
  }
}
